import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {Badge} from '@components/common/base/badge'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {Loader} from '@components/common/base/loader'
import {SelectWithCheckboxes} from '@components/common/base/select-with-dropdown/select-with-checkboxes'
import {useSearchStore} from '@components/right-panel/search/search-store'
import {globals} from '@extensions/globals-base'
import {idTasksApi} from '@extensions/id-tasks/id-tasks-store'
import {Project} from '@extensions/project'

const useOptions = () => {
  const [state] = useSearchStore()

  const projects = Project.listProjects(
    globals.getCompanyId(),
    'not-archive',
    true
  ).sort(Project.projectOrderComparer)

  const selected = new Set(state.filterState.projectIds)
  return projects.map(x => {
    const prefix = idTasksApi.getIdProject(x.id)
    return {
      key: x.id,
      text: x.title + ' ' + prefix,
      content: (
        <div className="flex-1 min-w-0 flex gap-8 items-center justify-between">
          <div className="flex-1 truncate">{x.title}</div>
          {prefix && (
            <Badge type="packed" className="flex-none">
              {prefix}
            </Badge>
          )}
        </div>
      ),
      selected: selected.has(x.id)
    }
  })
}

const useValue = () => {
  const [state] = useSearchStore()

  return useCallback(
    (options: OptionsItemCheckbox[]) => {
      let selected = 0
      options.forEach(x => (selected += Number(x.selected)))
      if (!selected || selected === options.length) {
        // All selected&none selected is the same state
        return Lang.msg.globalSearch.projectsAllCaption
      }

      const value: React.ReactNode[] = []
      state.filterState.projectIds.forEach((id, ix) => {
        const prefix = idTasksApi.getIdProject(id)
        ix && value.push(<React.Fragment key={ix}>,&nbsp;</React.Fragment>)
        value.push(
          prefix ? (
            <Badge key={id} type="packed" className="flex-none">
              {prefix}
            </Badge>
          ) : (
            <Loader size="xsmall" />
          )
        )
      })
      return <div className="flex overflow-hidden">{value}</div>
    },
    [state]
  )
}

export const ProjectSelect = () => {
  const [, store] = useSearchStore()
  const projectOptions = useOptions()
  const projectValue = useValue()

  return (
    <SelectWithCheckboxes
      allCaption={Lang.msg.globalSearch.projectsAllCaption}
      variant="new"
      innerClassName="w-[244px]"
      search
      options={projectOptions}
      value={projectValue}
      onChange={store.onChangeFilterProjects}
    />
  )
}
